import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fullHeight' && prop !== 'inline',
})(({ fullHeight, inline }) => {
  // Inline mode drops the centering wrapper entirely so the spinner
  // renders as an inline-flex element next to surrounding text —
  // use it for "Loading accounts…" patterns where a block-level
  // 100 %-width wrapper would push the label to the opposite edge.
  if (inline) {
    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      color: 'inherit',
    };
  }
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: fullHeight ? '100%' : 'auto',
    padding: fullHeight ? 0 : 24,
  };
});

/**
 * Loader — centred spinner.
 *
 * Props:
 *   - fullHeight: stretch to 100% height of parent (for full-page
 *                 loading states). Default: false.
 *   - inline:     render as inline-flex (no 100 %-width wrapper, no
 *                 padding). Use inside flex rows with labels so the
 *                 spinner sits next to the text. Default: false.
 *   - size:       spinner diameter in px. Default: 40.
 */
const Loader = ({ fullHeight = false, inline = false, size = 40 }) => (
  <Root fullHeight={fullHeight} inline={inline}>
    <CircularProgress size={size} />
  </Root>
);

export default Loader;
